// "Withdraw Decline Proposal" modal. Lightweight
// confirmation — no attestations. Returns the deal to Active; the original
// proposal and reason stay in the audit log.

import { Button } from "@/design-system/components/ui";
import { Modal } from "@/components/ui/Modal";
import { useToast } from "@/components/ui/Toast";
import { extractErrorMessage } from "@/api/client";
import { useWithdrawDeclineProposal } from "@/hooks/deals/useDeclineWorkflow";

interface Props {
  open: boolean;
  dealId: string;
  dealNumber: string;
  onClose: () => void;
}

export function DeclineWithdrawModal({ open, dealId, dealNumber, onClose }: Props) {
  const toast = useToast();
  const withdraw = useWithdrawDeclineProposal(dealId);

  async function submit() {
    if (withdraw.isPending) return;
    try {
      await withdraw.mutateAsync();
      toast.success("Decline proposal withdrawn. The deal is back to Active.");
      onClose();
    } catch (err) {
      toast.error(extractErrorMessage(err));
    }
  }

  return (
    <Modal
      open={open}
      onClose={withdraw.isPending ? () => {} : onClose}
      title="Withdraw Decline Proposal?"
      description={dealNumber}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={withdraw.isPending}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={submit}
            disabled={withdraw.isPending}
            loading={withdraw.isPending}
          >
            CONFIRM: WITHDRAW
          </Button>
        </>
      }
    >
      <p className="text-small text-gray-dark">
        The deal will return to <strong>Active</strong> status. The original
        proposal and reason will remain in the audit log.
      </p>
    </Modal>
  );
}
